import { ServiceIconShell } from '../ServiceIconShell';
import { isolateComponent } from '@zapier/style-encapsulation';
import { Img } from '../../display/Img';
import { ServiceIconConfig } from './constants';
export const ServiceIcon = ({ alt, ariaHidden = false, hasBorder = true, hasShadow = false, hasWhiteBackground = false, serviceName, size, src, }) => {
    const { iconSize } = ServiceIconConfig[size];
    return (isolateComponent(ServiceIconShell, { hasBorder: hasBorder, hasShadow: hasShadow, hasWhiteBackground: hasWhiteBackground, size: size },
        isolateComponent(Img, { alt: alt || `${serviceName} logo`, ariaHidden: ariaHidden, borderRadius: 0, height: iconSize, objectFit: "contain", src: src, width: iconSize })));
};
//# sourceMappingURL=ServiceIcon.js.map
// @zapier/design-system@6.28.0 (14d5b99c8)
